import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login"
import {useAuth} from "./auth/AuthProvider";

dayjs.locale("ru");


const App = () => {
    const {user} = useAuth();

    return user ? <Dashboard/> : <Login/>;
};

export default App
